import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {
 public closeSidebarSubject = new Subject<void>();
   private pageLoadSubject = new Subject<boolean>();
  pageLoad$: Observable<boolean> = this.pageLoadSubject.asObservable();
  constructor() { }

   closeSidebar() {
    this.closeSidebarSubject.next();
  }

   // Call to notify page/component load
  loadPage(flag: boolean = true) {
    this.pageLoadSubject.next(flag);
  }
}
